"use client";
import { useTranslations } from "next-intl";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

import Link from "next/link";
import React, { useEffect, useRef } from "react";
import ArrowLeftIcon from "@/components/_icons/arrowLeftIcon";

export const CustomerProfileHeader = () => {
  const t = useTranslations("CustomerProfileHeader");
  const headerRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.focus();
    }
  }, []);
  return (
    <div
      data-testid={applyDataTestId(pom.customerProfile.customerProfileHeader)}
      className={[
        "flex",
        "flex-col",
        "items-center",
        "relative",
        "sm:sticky",
        "top-0",
        "z-20",
        "bg-white",
        "shadow-md",
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-row",
          "px-10",
          "py-8",
          "w-full",
          "justify-between",
        ].join(" ")}
      >
        <Link ref={headerRef} href="/">
          <div
            className={["flex", "flex-row", "gap-3", "items-center"].join(" ")}
          >
            <ArrowLeftIcon />

            <span className="text-[20px] font-medium text-[#373737]">
              {t("account")}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
};
